import { render, staticRenderFns } from "./OwnerEdit.vue?vue&type=template&id=24d746f6&scoped=true"
import script from "./OwnerEdit.vue?vue&type=script&lang=js"
export * from "./OwnerEdit.vue?vue&type=script&lang=js"
import style0 from "./OwnerEdit.vue?vue&type=style&index=0&id=24d746f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d746f6",
  null
  
)

export default component.exports